// Global variables
let navStateInput = null;

/**
 * Handle click on a mainNavElement
 * If element isn't a link:
 *     - simulate click on chevron to open submenu
 * If element is link:
 *     - Close menu
 *     - (and follow link)
 *
 * @param mainNavLink
 * @private
 */
function _handleNavItemClick(mainNavLink) {
  if (mainNavLink.tagName !== 'A') {
    mainNavLink.chevron && mainNavLink.chevron.click();
  } else {
    navStateInput.checked = false;
    document.body.removeAttribute('menuopen');
  }
}

/**
 * Get all main nav links and listen to clicks
 */
document.addEventListener('DOMContentLoaded', () => {
  navStateInput = document.querySelector('#navigation-state');
  const mainNavLinks = document.querySelectorAll('.navigation--main .navigation-item__link');

  if (!mainNavLinks || !navStateInput) return;

  mainNavLinks.forEach((mainNavLink) => {
    mainNavLink.addEventListener('click', () => {
      mainNavLink.chevron = mainNavLink.parentNode.querySelector('.navigation-item__toggle-state');
      _handleNavItemClick(mainNavLink);
    });
  });
});
